module.exports = __webpack_public_path__ + "static/media/xilinx_board.50dbb239.png";